<template>
  <div class="company-profile-page">
    <div class="container edit-user-template">
      <div class="content-not-ready-container" v-if="loading">
        <div class="content-not-ready border-1-100"></div>
      </div>
      <h1 class="page-header color-1-100">Organisation profile</h1>
      <div class="flex-block">
        <div class="content-left-section">
          <div class="content-section no-margin-top progress-section"
               tabindex="-1">
            <div>
              <div class="content-section-title color-1-100 background-1-100-before">
                <h3>Progress chart</h3>
                <div class="content-company-badge"
                     id="contentCompanyBadge"
                     @click.prevent="badgeCopy = true"
                     v-if="user">
                  <iframe v-bind:title="user && user.company ? user.company.name + ' badge' : 'Company badge'" width="210" height="85"
                          :src="getBadgeLink() + '?company=' + (user.company ? user.company.hash : '') + '&theme=' + (selectedHightCont === 1 ? 'dark' : 'light')"></iframe>
                </div>
              </div>
              <div class="content-chart-date" aria-hidden="true">{{ getCurrentDate() }}</div>
              <div class="content-chart-wrapper">
                <div class="content-chart-legend-y" aria-hidden="true">
                  <div class="content-chart-legend-y__item level-5"><span>Platinum</span></div>
                  <div class="content-chart-legend-y__item level-4"><span>Gold</span></div>
                  <div class="content-chart-legend-y__item level-3"><span>Silver</span></div>
                  <div class="content-chart-legend-y__item level-2"><span>Bronze</span></div>
                  <div class="content-chart-legend-y__item level-1"><span>Foundation</span></div>
                </div>
                <div class="content-chart-body" aria-hidden="true">
                  <div v-bind:style="{ width: getChartWidth(chartData, true) }">
                    <div class="content-chart-data" v-bind:style="{ width: getChartWidth(chartData, true) }">
                      <div class="content-loading"
                           v-if="!chartData">
                      </div>
                      <div class="content-chart-grid">
                        <div class="content-chart-grid-line line_10"></div>
                        <div class="content-chart-grid-line line_9" v-bind:style="{ width: getChartWidth(chartData, false) }"></div>
                        <div class="content-chart-grid-line line_8" v-bind:style="{ width: getChartWidth(chartData, false) }"></div>
                        <div class="content-chart-grid-line line_7" v-bind:style="{ width: getChartWidth(chartData, false) }"></div>
                        <div class="content-chart-grid-line line_6" v-bind:style="{ width: getChartWidth(chartData, false) }"></div>
                        <div class="content-chart-grid-line line_5" v-bind:style="{ width: getChartWidth(chartData, false) }"></div>
                        <div class="content-chart-grid-line line_4" v-bind:style="{ width: getChartWidth(chartData, false) }"></div>
                        <div class="content-chart-grid-line line_3" v-bind:style="{ width: getChartWidth(chartData, false) }"></div>
                        <div class="content-chart-grid-line line_2" v-bind:style="{ width: getChartWidth(chartData, false) }"></div>
                        <div class="content-chart-grid-line line_1" v-bind:style="{ width: getChartWidth(chartData, false) }"></div>
                      </div>
                      <div class="content-chart-points"
                           v-if="c"
                           v-for="(c, index) in chartData">
                        <div class="content-chart-point"
                             :class="'chapter__' + c.chapter.id"
                             :data-chapter="'chapter-legend-' + c.chapter.id"
                             :data-color="c.chapter.color"
                             v-bind:style="{left: p.left + 'px', top: p.top + '%', borderColor: c.chapter.color }"
                             v-for="p in c.scores">
                        </div>
                        <div class="content-chart-chapters__item"
                             :class="'chapter_' + getChapterIndex(c)"
                             @click.prevent="addChapterHover(c, 'level')"
                             :id="'chapter-legend-' + c.chapter.id"
                             v-bind:style="{
                           backgroundColor: c.hover && c.hover.type === 'level' && c.hover.show === true ? c.chapter.color : '',
                           color: selectedHightCont === 1 ? (c.hover && c.hover.type === 'level' && c.hover.show === true ? '#000000' : c.chapter.color) : c.hover && c.hover.type === 'level' && c.hover.show === true ? '#000000' : '',
                           borderColor: c.chapter.color
                         }">
                          {{ getChapterCustomName(c.chapter) }}</div>
                        <span class="show-benchmark tooltip"
                              v-if="hasBenchmark(c)"
                              @click.prevent="addChapterHover(c, 'benchmark')"
                              :class="[{ 'active': c.hover && c.hover.type === 'benchmark' && c.hover.show === true }, 'chapter_' + getChapterIndex(c)]">
                      <span class="tooltip-text">Show benchmark</span>
                    </span>
                        <div class="chapter-level"
                             v-bind:style="{ top: (100 - c.hover.top) + '%', height: c.hover.top + '%'}"
                             v-if="c.hover && c.hover.type === 'level' && c.hover.show === true"></div>
                        <div class="chapter-benchmark"
                             v-bind:style="{ top: (100 - c.hover.top) + '%', height: c.hover.top + '%'}"
                             v-if="c.hover && c.hover.type === 'benchmark' && c.hover.show === true"></div>
                      </div>
                    </div>
                    <div class="content-chart-legend-x" v-bind:style="{ width: getChartWidth(chartData, true) }">
                      <div class="content-chart-legend-x__item" v-for="quarter in reverseItems(quarters)">
                        Q{{ quarter.quarter }} {{ quarter.year }}
                      </div>
                    </div>
                  </div>
                </div>
                <div id="chartAccessibilityTable"
                     class="chart-accessibility-table"
                     tabindex="-1">
                  <table>
                    <caption>{{ (user && user.company) ? user.company.name : 'Company' }} progress</caption>
                    <thead>
                    <tr>
                      <td>Task category</td>
                      <th scope="col" v-for="quarter in reverseItems(quarters)">Q{{ quarter.quarter }} {{ quarter.year }}</th>
                      <th scope="col">Industry benchmark</th>
                    </tr>
                    </thead>
                    <tr v-for="c in chartData" v-if="c">
                      <th scope="row">
                        {{ getChapterCustomName(c.chapter) }}
                        <!--<template v-if="c.chapter.id === company.focusArea.id">
                          (company focus)
                        </template>-->
                      </th>
                      <template v-for="(p, index) in c.scores">
                        <td>{{ p.score }}</td>
                        <td v-if="index === (c.scores.length - 1)">{{ p.benchmark }}</td>
                      </template>
                    </tr>
                  </table>
                </div>
              </div>
            </div>
            <div class="progress-action-links">
              <button class="background-1-20 background-1-100-hover" @click.prevent="htmlToCanvas2()">
              <span class="color-1-100">
                <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                     viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
                  <g>
                    <g>
                      <path class="st0" d="M501.333,490.667H10.667C4.779,490.667,0,495.445,0,501.333C0,507.221,4.779,512,10.667,512h490.667
                        c5.888,0,10.667-4.779,10.667-10.667C512,495.445,507.221,490.667,501.333,490.667z"/>
                    </g>
                  </g>
                  <g>
                    <g>
                      <path class="st0" d="M96,362.667H32c-5.888,0-10.667,4.779-10.667,10.667v128C21.333,507.221,26.112,512,32,512h64
                        c5.888,0,10.667-4.779,10.667-10.667v-128C106.667,367.445,101.888,362.667,96,362.667z M85.333,490.667H42.667V384h42.667
                        V490.667z"/>
                    </g>
                  </g>
                  <g>
                    <g>
                      <path class="st0" d="M224,256h-64c-5.888,0-10.667,4.779-10.667,10.667v234.667c0,5.888,4.779,10.667,10.667,10.667h64
                        c5.888,0,10.667-4.779,10.667-10.667V266.667C234.667,260.779,229.888,256,224,256z M213.333,490.667h-42.667V277.333h42.667
                        V490.667z"/>
                    </g>
                  </g>
                  <g>
                    <g>
                      <path class="st0" d="M352,298.667h-64c-5.888,0-10.667,4.779-10.667,10.667v192c0,5.888,4.779,10.667,10.667,10.667h64
                        c5.888,0,10.667-4.779,10.667-10.667v-192C362.667,303.445,357.888,298.667,352,298.667z M341.333,490.667h-42.667V320h42.667
                        V490.667z"/>
                    </g>
                  </g>
                  <g>
                    <g>
                      <path class="st0" d="M480,170.667h-64c-5.888,0-10.667,4.779-10.667,10.667v320c0,5.888,4.779,10.667,10.667,10.667h64
                        c5.888,0,10.667-4.779,10.667-10.667v-320C490.667,175.445,485.888,170.667,480,170.667z M469.333,490.667h-42.667V192h42.667
                        V490.667z"/>
                    </g>
                  </g>
                  <g>
                    <g>
                      <path class="st0" d="M64,192c-23.531,0-42.667,19.136-42.667,42.667c0,23.531,19.136,42.667,42.667,42.667
                        c23.531,0,42.667-19.136,42.667-42.667C106.667,211.136,87.531,192,64,192z M64,256c-11.776,0-21.333-9.579-21.333-21.333
                        c0-11.755,9.557-21.333,21.333-21.333s21.333,9.579,21.333,21.333C85.333,246.421,75.776,256,64,256z"/>
                    </g>
                  </g>
                  <g>
                    <g>
                      <path class="st0" d="M192,85.333c-23.531,0-42.667,19.136-42.667,42.667c0,23.531,19.136,42.667,42.667,42.667s42.667-19.136,42.667-42.667
                        C234.667,104.469,215.531,85.333,192,85.333z M192,149.333c-11.776,0-21.333-9.579-21.333-21.333
                        c0-11.755,9.557-21.333,21.333-21.333s21.333,9.579,21.333,21.333C213.333,139.755,203.776,149.333,192,149.333z"/>
                    </g>
                  </g>
                  <g>
                    <g>
                      <path class="st0" d="M320,128c-23.531,0-42.667,19.136-42.667,42.667c0,23.531,19.136,42.667,42.667,42.667
                        c23.531,0,42.667-19.136,42.667-42.667C362.667,147.136,343.531,128,320,128z M320,192c-11.776,0-21.333-9.579-21.333-21.333
                        c0-11.755,9.557-21.333,21.333-21.333s21.333,9.579,21.333,21.333C341.333,182.421,331.776,192,320,192z"/>
                    </g>
                  </g>
                  <g>
                    <g>
                      <path class="st0" d="M448,0c-23.531,0-42.667,19.136-42.667,42.667c0,23.531,19.136,42.667,42.667,42.667
                        c23.531,0,42.667-19.136,42.667-42.667C490.667,19.136,471.531,0,448,0z M448,64c-11.776,0-21.333-9.579-21.333-21.333
                        c0-11.755,9.557-21.333,21.333-21.333s21.333,9.579,21.333,21.333C469.333,54.421,459.776,64,448,64z"/>
                    </g>
                  </g>
                  <g>
                    <g>
                      <path class="st0" d="M432.939,57.728c-4.16-4.16-10.923-4.16-15.083,0l-82.773,82.773c-4.16,4.16-4.16,10.923,0,15.083
                        c2.091,2.069,4.821,3.115,7.552,3.115c2.709,0,5.44-1.024,7.531-3.115l82.773-82.773
                        C437.099,68.651,437.099,61.888,432.939,57.728z"/>
                    </g>
                  </g>
                  <g>
                    <g>
                      <path class="st0" d="M294.208,146.048l-68.523-19.541c-5.739-1.664-11.563,1.664-13.163,7.339c-1.621,5.675,1.664,11.563,7.317,13.184
                        l68.523,19.541c0.981,0.277,1.963,0.405,2.923,0.405c4.651,0,8.917-3.051,10.261-7.744
                        C303.168,153.579,299.883,147.669,294.208,146.048z"/>
                    </g>
                  </g>
                  <g>
                    <g>
                      <path class="st0" d="M175.36,141.291c-3.669-4.608-10.368-5.355-14.976-1.707l-80.427,64.128c-4.608,3.691-5.376,10.389-1.685,14.997
                        c2.112,2.645,5.227,4.011,8.341,4.011c2.325,0,4.672-0.768,6.635-2.304l80.427-64.128
                        C178.283,152.597,179.051,145.899,175.36,141.291z"/>
                    </g>
                  </g>
                </svg>
              </span>
                Download Progress chart
              </button>
              <button class="background-1-20 background-1-100-hover" @click.prevent="badgeCopy = true">
              <span class="color-1-100">
                <svg xmlns="http://www.w3.org/2000/svg" height="511pt" version="1.1" viewBox="-55 0 511 511.9999" width="511pt">
                  <g id="surface1">
                    <path class="st0" d="M 335.175781 190.992188 C 335.175781 117.195312 275.136719 57.15625 201.339844 57.15625 C 127.539062 57.15625 67.5 117.195312 67.5 190.992188 C 67.5 264.792969 127.539062 324.832031 201.339844 324.832031 C 275.136719 324.832031 335.175781 264.792969 335.175781 190.992188 Z M 201.339844 309.832031 C 135.8125 309.832031 82.5 256.519531 82.5 190.992188 C 82.5 125.46875 135.8125 72.15625 201.339844 72.15625 C 266.867188 72.15625 320.175781 125.46875 320.175781 190.992188 C 320.175781 256.519531 266.867188 309.832031 201.339844 309.832031 Z M 201.339844 309.832031 " />
                    <path class="st0" d="M 294.546875 161.652344 C 293.132812 157.292969 289.105469 154.367188 284.523438 154.367188 L 228.632812 154.367188 L 211.363281 101.214844 C 209.945312 96.859375 205.917969 93.933594 201.339844 93.933594 C 196.761719 93.933594 192.734375 96.859375 191.316406 101.214844 L 174.046875 154.371094 L 118.15625 154.371094 C 113.574219 154.371094 109.546875 157.296875 108.132812 161.652344 C 106.71875 166.007812 108.257812 170.742188 111.960938 173.433594 L 157.175781 206.285156 L 139.90625 259.4375 C 138.492188 263.792969 140.027344 268.53125 143.734375 271.222656 C 147.4375 273.914062 152.417969 273.914062 156.125 271.222656 L 201.339844 238.371094 L 246.554688 271.222656 C 248.410156 272.570312 250.578125 273.242188 252.75 273.242188 C 254.921875 273.242188 257.09375 272.570312 258.945312 271.222656 C 262.652344 268.53125 264.1875 263.792969 262.773438 259.4375 L 245.5 206.285156 L 290.714844 173.433594 C 294.421875 170.742188 295.960938 166.007812 294.546875 161.652344 Z M 234.0625 196.054688 C 230.359375 198.746094 228.820312 203.480469 230.234375 207.839844 L 244.261719 251.015625 L 207.535156 224.332031 C 205.679688 222.984375 203.511719 222.3125 201.339844 222.3125 C 199.167969 222.3125 196.996094 222.984375 195.144531 224.332031 L 158.417969 251.015625 L 172.445312 207.835938 C 173.859375 203.480469 172.320312 198.746094 168.617188 196.054688 L 131.886719 169.367188 L 177.289062 169.367188 C 181.867188 169.367188 185.894531 166.441406 187.3125 162.085938 L 201.339844 118.90625 L 215.367188 162.085938 C 216.785156 166.441406 220.8125 169.367188 225.390625 169.367188 L 270.792969 169.367188 Z M 234.0625 196.054688 " />
                    <path class="st0" d="M 400.640625 439.113281 L 330.316406 315.652344 L 342.636719 311.699219 C 357.480469 306.941406 367.277344 292.746094 366.464844 277.179688 L 365.53125 259.300781 C 365.246094 253.890625 367.261719 248.570312 371.0625 244.707031 L 383.621094 231.945312 C 394.550781 220.832031 396.628906 203.710938 388.675781 190.304688 L 379.539062 174.910156 C 376.773438 170.25 376.089844 164.601562 377.65625 159.414062 L 382.84375 142.277344 C 387.359375 127.359375 381.242188 111.234375 367.972656 103.0625 L 352.726562 93.671875 C 348.113281 90.832031 344.878906 86.152344 343.859375 80.828125 L 340.488281 63.246094 C 337.554688 47.9375 324.644531 36.5 309.09375 35.429688 L 291.230469 34.203125 C 285.824219 33.832031 280.789062 31.1875 277.414062 26.949219 L 266.253906 12.945312 C 256.542969 0.757812 239.792969 -3.367188 225.53125 2.910156 L 209.144531 10.125 C 209.144531 10.125 209.144531 10.125 209.140625 10.125 C 204.183594 12.308594 198.496094 12.308594 193.535156 10.125 L 177.148438 2.910156 C 162.882812 -3.367188 146.136719 0.757812 136.421875 12.949219 L 125.265625 26.949219 C 121.890625 31.1875 116.855469 33.832031 111.449219 34.203125 L 93.585938 35.429688 C 78.035156 36.5 65.125 47.9375 62.191406 63.246094 L 58.820312 80.828125 C 57.796875 86.148438 54.566406 90.832031 49.953125 93.671875 L 34.707031 103.058594 C 21.4375 111.230469 15.320312 127.359375 19.835938 142.277344 L 25.019531 159.414062 C 26.589844 164.601562 25.90625 170.246094 23.140625 174.90625 L 14.003906 190.304688 C 6.050781 203.707031 8.128906 220.832031 19.058594 231.941406 L 31.617188 244.707031 C 35.414062 248.570312 37.433594 253.886719 37.148438 259.296875 L 36.214844 277.179688 C 35.402344 292.742188 45.199219 306.9375 60.039062 311.699219 L 72.363281 315.648438 L 2.039062 439.113281 C -0.0859375 442.84375 -0.0078125 447.429688 2.246094 451.085938 C 4.5 454.742188 8.582031 456.882812 12.851562 456.648438 L 71.628906 453.605469 L 98.992188 505.71875 C 100.988281 509.515625 104.894531 511.925781 109.1875 511.996094 C 109.253906 511.996094 109.320312 512 109.386719 512 C 113.601562 512 117.5 509.742188 119.589844 506.070312 L 191.15625 380.421875 C 194.46875 381.449219 197.902344 381.984375 201.339844 381.984375 C 204.777344 381.984375 208.207031 381.449219 211.523438 380.421875 L 283.089844 506.070312 C 285.179688 509.742188 289.074219 512 293.289062 512 C 293.355469 512 293.425781 512 293.492188 511.996094 C 297.785156 511.925781 301.691406 509.519531 303.6875 505.71875 L 331.046875 453.605469 L 389.828125 456.648438 C 394.132812 456.875 398.179688 454.738281 400.429688 451.085938 C 402.683594 447.429688 402.765625 442.84375 400.640625 439.113281 Z M 109.503906 493.472656 L 84.582031 446.011719 L 99.296875 420.183594 C 101.347656 416.582031 100.09375 412.003906 96.492188 409.953125 C 92.898438 407.90625 88.316406 409.160156 86.265625 412.757812 L 71.550781 438.589844 L 18.019531 441.363281 L 85.605469 322.710938 C 86.878906 324.136719 87.957031 325.75 88.769531 327.515625 L 96.253906 343.785156 C 100.136719 352.226562 107.136719 358.484375 115.40625 361.589844 L 103.6875 382.167969 C 101.636719 385.765625 102.894531 390.347656 106.492188 392.398438 C 107.664062 393.0625 108.941406 393.378906 110.199219 393.378906 C 112.804688 393.378906 115.339844 392.019531 116.722656 389.589844 L 131.5625 363.539062 C 132.171875 363.464844 132.78125 363.382812 133.390625 363.273438 L 151.03125 360.191406 C 156.363281 359.257812 161.886719 360.621094 166.179688 363.925781 L 178.074219 373.085938 Z M 211.089844 364.339844 C 211.0625 364.355469 211.039062 364.363281 211.015625 364.378906 C 210.976562 364.402344 210.9375 364.429688 210.898438 364.453125 C 204.980469 367.816406 197.699219 367.816406 191.78125 364.453125 C 191.742188 364.429688 191.707031 364.402344 191.664062 364.378906 C 191.640625 364.363281 191.617188 364.355469 191.59375 364.339844 C 190.882812 363.925781 190.1875 363.480469 189.523438 362.96875 L 175.335938 352.042969 C 169.292969 347.386719 161.875 344.902344 154.335938 344.902344 C 152.375 344.902344 150.40625 345.074219 148.449219 345.414062 L 130.808594 348.496094 C 129.671875 348.695312 128.535156 348.785156 127.410156 348.78125 C 127.316406 348.777344 127.226562 348.773438 127.136719 348.773438 C 119.8125 348.644531 113.03125 344.359375 109.882812 337.511719 L 102.398438 321.246094 C 99.199219 314.289062 93.75 308.636719 87.042969 305.136719 C 87.027344 305.128906 87.015625 305.117188 87 305.109375 C 86.957031 305.085938 86.914062 305.066406 86.875 305.046875 C 86.714844 304.964844 86.554688 304.882812 86.394531 304.804688 C 86.355469 304.785156 86.324219 304.769531 86.285156 304.753906 C 84.800781 304.023438 83.261719 303.394531 81.671875 302.882812 L 64.621094 297.417969 C 56.257812 294.734375 50.734375 286.734375 51.195312 277.964844 L 52.128906 260.082031 C 52.628906 250.480469 49.050781 241.042969 42.308594 234.191406 L 29.753906 221.425781 C 23.59375 215.164062 22.421875 205.515625 26.902344 197.960938 L 36.039062 182.5625 C 40.945312 174.292969 42.164062 164.273438 39.378906 155.070312 L 34.191406 137.933594 C 31.644531 129.527344 35.09375 120.4375 42.574219 115.835938 L 57.820312 106.445312 C 66.007812 101.402344 71.742188 93.097656 73.550781 83.652344 L 76.921875 66.070312 C 78.574219 57.445312 85.851562 51 94.613281 50.394531 L 112.476562 49.167969 C 122.066406 48.507812 131.003906 43.816406 136.996094 36.296875 L 148.152344 22.296875 C 153.628906 15.425781 163.066406 13.101562 171.105469 16.640625 L 187.488281 23.851562 C 196.289062 27.726562 206.386719 27.726562 215.183594 23.851562 L 231.570312 16.640625 C 239.613281 13.101562 249.046875 15.425781 254.519531 22.296875 L 265.679688 36.300781 C 271.667969 43.820312 280.609375 48.507812 290.199219 49.167969 L 308.0625 50.398438 C 316.824219 51 324.101562 57.445312 325.753906 66.070312 L 329.125 83.65625 C 330.9375 93.097656 336.671875 101.40625 344.855469 106.445312 L 360.101562 115.835938 C 367.582031 120.441406 371.03125 129.527344 368.484375 137.933594 L 363.296875 155.074219 C 360.511719 164.273438 361.730469 174.292969 366.636719 182.566406 L 375.773438 197.960938 C 380.253906 205.515625 379.085938 215.164062 372.921875 221.425781 L 360.367188 234.191406 C 353.625 241.042969 350.046875 250.480469 350.546875 260.085938 L 351.480469 277.964844 C 351.941406 286.734375 346.417969 294.734375 338.054688 297.417969 L 321.003906 302.882812 C 319.414062 303.394531 317.875 304.023438 316.390625 304.75 C 316.351562 304.769531 316.316406 304.785156 316.28125 304.800781 C 316.121094 304.882812 315.957031 304.964844 315.796875 305.046875 C 315.757812 305.070312 315.714844 305.085938 315.675781 305.109375 C 315.660156 305.117188 315.648438 305.125 315.636719 305.132812 C 308.925781 308.632812 303.476562 314.289062 300.277344 321.246094 L 292.792969 337.515625 C 289.648438 344.355469 282.875 348.640625 275.554688 348.773438 C 275.449219 348.773438 275.339844 348.777344 275.234375 348.785156 C 274.117188 348.785156 272.992188 348.695312 271.863281 348.496094 L 254.226562 345.414062 C 244.753906 343.757812 234.953125 346.175781 227.335938 352.042969 L 213.152344 362.96875 C 212.492188 363.480469 211.796875 363.925781 211.089844 364.339844 Z M 331.128906 438.589844 L 316.292969 412.546875 C 314.242188 408.945312 309.660156 407.691406 306.066406 409.742188 C 302.464844 411.792969 301.210938 416.371094 303.261719 419.972656 L 318.09375 446.011719 L 293.175781 493.472656 L 224.605469 373.085938 L 236.496094 363.925781 C 240.789062 360.621094 246.3125 359.257812 251.648438 360.191406 L 269.285156 363.273438 C 269.894531 363.382812 270.507812 363.464844 271.117188 363.539062 L 285.949219 389.582031 C 287.332031 392.007812 289.867188 393.371094 292.472656 393.371094 C 293.730469 393.371094 295.007812 393.054688 296.179688 392.386719 C 299.777344 390.335938 301.03125 385.757812 298.984375 382.15625 L 287.269531 361.589844 C 295.539062 358.480469 302.539062 352.226562 306.421875 343.785156 L 313.90625 327.515625 C 314.71875 325.75 315.796875 324.136719 317.070312 322.710938 L 384.65625 441.363281 Z M 331.128906 438.589844 " />
                  </g>
                </svg>
              </span>
                Embed badge to your website
              </button>
            </div>
          </div>
          <div class="content-section no-margin-top progress-section"
               tabindex="-1">
            <div class="content-section-title color-1-100 background-1-100-before">
              <h3>Task categories</h3>
              <div class="content-chapters">
                <!--<a href="#" class="content-chapters__item background-1-100-after background-1-50-child-hover main-svg-stroke-color-one-50"
                   :aria-label="getChapterCustomName(chapter.chapter) + ', level: ' + chapter.scores.level.name + ', ' + chapter.scores.score + '% complete'"
                   @click.prevent="goToContentPage(chapter.chapter)"
                   :class="[{ 'is-focus': chapter.isFocus && getUserRole !== 'ta' && getUserRole !== 'tu' }]"
                   v-for="chapter in chapters">
                  <div class="content-chapters__item__focus background-1-100" v-if="chapter.isFocus && getUserRole !== 'ta' && getUserRole !== 'tu'">
                    <span>Company focus</span>
                  </div>-->
                <router-link :to="getContentPageProps(chapter.chapter)" class="content-chapters__item background-1-100-after background-1-50-child-hover main-svg-stroke-color-one-50"
                             :aria-label="getChapterCustomName(chapter.chapter) + ', level: ' + chapter.scores.level.name + ', ' + chapter.scores.score + '% complete'"
                             @contextmenu="this.gaRelatedClicked(chapter.chapter)"
                             @click="this.gaRelatedClicked(chapter.chapter)"
                             v-bind:key="chapter.chapter.id"
                             v-for="chapter in chapters">
                  <div class="content-chapters_progress__icon">
                    <div class="content-chapters_image" v-bind:style="{backgroundImage: getChapterBackground(chapter.chapter) }"></div>
                    <svg class="progress" width="130" height="130" viewBox="0 0 100 100">
                      <circle class="progress__meter" cx="50" cy="50" r="44" stroke-width="5"/>
                      <circle class="chapter__progress__value"
                              :class="'progress__value-' + chapter.chapter.id"
                              cx="50" cy="50" r="44"
                              v-if="getUserRole !== 'ta' && getUserRole !== 'tu'"
                              stroke-width="5"/>
                    </svg>
                  </div>
                  <div class="content-chapters__item-name background-1-10 background-1-50-hover color-2-100">
                    {{ getChapterCustomName(chapter.chapter) }}
                  </div>
                  <span class="content-chapters__item-level content-chapters__item-level-custom"
                        v-if="getUserRole !== 'ta' && getUserRole !== 'tu' && getUserRole !== 'la' && getUserRole !== 'lu'"
                        :class="[chapter.scores.level.id === 5 ? 'color-1-100' : 'color-2-77', 'level-' + chapter.scores.level.id]">
                  <span class="progress-level-icon" :class="chapter.scores.level.id <= 4 ? 'type-one' : 'type-two'">
                      <template v-if="chapter.scores.level.id === 1">
                        <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                             viewBox="0 0 5 3" style="enable-background:new 0 0 5 3;" xml:space="preserve">
                          <g id="XMLID_53_">
                            <path id="XMLID_15_" class="st0" d="M5,3H0V2.5C0,1.119,1.119,0,2.5,0h0C3.881,0,5,1.119,5,2.5V3z"/>
                          </g>
                        </svg>
                      </template>
                      <template v-if="chapter.scores.level.id === 2">
                        <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                             viewBox="0 0 10 6" style="enable-background:new 0 0 10 6;" xml:space="preserve">
                          <g id="XMLID_53_">
                            <path id="XMLID_15_" class="st0" d="M5,6H0V5.5C0,4.119,1.119,3,2.5,3h0C3.881,3,5,4.119,5,5.5V6z"/>
                            <path id="XMLID_17_" class="st1" d="M10,6H5V2.5C5,1.119,6.119,0,7.5,0h0C8.881,0,10,1.119,10,2.5V6z"/>
                          </g>
                        </svg>
                      </template>
                      <template v-if="chapter.scores.level.id === 3">
                        <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                             viewBox="0 0 15 9" style="enable-background:new 0 0 15 9;" xml:space="preserve">
                          <g id="XMLID_53_">
                            <path id="XMLID_15_" class="st0" d="M5,9H0V8.5C0,7.119,1.119,6,2.5,6h0C3.881,6,5,7.119,5,8.5V9z"/>
                            <path id="XMLID_17_" class="st1" d="M10,9H5V5.5C5,4.119,6.119,3,7.5,3h0C8.881,3,10,4.119,10,5.5V9z"/>
                            <path id="XMLID_18_" class="st2" d="M15,9h-5V2.5C10,1.119,11.119,0,12.5,0h0C13.881,0,15,1.119,15,2.5V9z"/>
                          </g>
                        </svg>
                      </template>
                      <template v-if="chapter.scores.level.id === 4">
                        <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                             viewBox="0 0 15 9" style="enable-background:new 0 0 15 9;" xml:space="preserve">
                          <g id="XMLID_53_">
                            <path id="XMLID_15_" class="st0" d="M5,9H0V8.5C0,7.119,1.119,6,2.5,6h0C3.881,6,5,7.119,5,8.5V9z"/>
                            <path id="XMLID_17_" class="st1" d="M10,9H5V5.5C5,4.119,6.119,3,7.5,3h0C8.881,3,10,4.119,10,5.5V9z"/>
                            <path id="XMLID_18_" class="st2" d="M15,9h-5V2.5C10,1.119,11.119,0,12.5,0h0C13.881,0,15,1.119,15,2.5V9z"/>
                          </g>
                        </svg>
                      </template>
                      <template v-if="chapter.scores.level.id === 5">
                        <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                             viewBox="0 0 25 15" style="enable-background:new 0 0 25 15;" xml:space="preserve">
                          <g id="XMLID_53_">
                            <path id="XMLID_14_" class="st0" d="M25,15h-5V2.5C20,1.125,21.125,0,22.5,0h0C23.875,0,25,1.125,25,2.5V15z"/>
                            <path id="XMLID_15_" class="st1" d="M5,14.999H0v-0.5c0-1.381,1.119-2.5,2.5-2.5h0c1.381,0,2.5,1.119,2.5,2.5V14.999z"/>
                            <path id="XMLID_17_" class="st2" d="M10,14.999H5v-3.5c0-1.381,1.119-2.5,2.5-2.5h0c1.381,0,2.5,1.119,2.5,2.5V14.999z"/>
                            <path id="XMLID_18_" class="st3" d="M15,14.999h-5v-6.5c0-1.381,1.119-2.5,2.5-2.5h0c1.381,0,2.5,1.119,2.5,2.5V14.999z"/>
                            <path id="XMLID_19_" class="st4" d="M20,14.999h-5v-9.5c0-1.381,1.119-2.5,2.5-2.5h0c1.381,0,2.5,1.119,2.5,2.5V14.999z"/>
                          </g>
                        </svg>
                      </template>
                    </span>
                  <span >
                    Level: {{ chapter.scores.level.name }}
                  </span>
                </span>
                </router-link>
                <div class="clearfix"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="badge-copy" v-if="badgeCopy === true">
        <div class="badge-copy-container" aria-modal="true" aria-labelledby="confirmation-popup-title">
          <h2 id="confirmation-popup-title" style="color: #777777;">Embed ClearAssured to your website</h2>
          <div class="badge-copy-selector">
            <div class="form-element">
              <label for="iframe-themes" class="form-label color-2-63">Theme</label>
              <v-select class="form-control form-control__select background-1-10-child  border-1-10-child background-2-10-locked border-2-10-locked"
                        :searchable=true
                        :placeholder="'Theme'"
                        v-model="iframeTheme"
                        :options="iframeThemes"
                        data-lpignore="true"
                        id="iframe-themes"/>
            </div>
          </div>
          <div class="badge-copy-iframe" :class="iframeTheme.value">
            <iframe  v-bind:title="user && user.company ? user.company.name + ' badge' : 'Company badge'"
                     width="210" height="85"
                     id="previewIframe"
                     :src="getBadgeLink() + '?company=' + (user.company ? user.company.hash : '') + '&theme=' + iframeTheme.value"></iframe>
          </div>
          <div class="badge-copy-code">
            <button @click.prevent="copyIframe()" aria-label="Copy company badge code">Copy</button>
            <textarea v-bind:title="user && user.company ? user.company.name + ' badge code' : 'Company badge code'"
                      aria-placeholder="The embed code was copied to your clipboard"
                      aria-hidden="true"
                      id="iframeCode"
                      rows="3"
                      cols="50"
                      onclick="this.focus(); this.select()"
                      readonly="readonly">{{ getIframeCode() }}</textarea>
          </div>
          <button class="badge-copy-close"
                  aria-label="Close dialog"
                  @click.prevent="badgeCopy = false"></button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  import Vue from 'vue'
  import api from '@/api'
  import html2canvas from 'html2canvas'
  import htmlToImage from 'html-to-image'

  export default {
    name: 'company-profile',
    data () {
      return {
        user: null,
        chapters: null,
        quarters: null,
        chartData: null,
        hasPoints: false,
        company: {
          focusArea: {
            id: null,
            image: '',
            name: ''
          },
          level: {
            id: null,
            name: '',
            score: 0
          }
        },
        badgeCopy: false,
        iframeTheme: {
          label: 'Light',
          value: 'light'
        },
        loading: false
      }
    },
    computed: {
      ...mapGetters([
        'getUserRole',
        'selectedHightCont'
      ]),
      iframeThemes () {
        return [
          {
            label: 'Light',
            value: 'light'
          },
          {
            label: 'Dark',
            value: 'dark'
          }
        ]
      }
    },
    components: {},
    methods: {
      ...mapActions([]),
      getUserInfoById () {
        this.$http.put(api.URLS.profile, {}, api.headersAuthSettings)
          .then((res) => {
            this.user = res.body
            let quarters = res.body.company.points.sort((a, b) => -1 * (parseInt(a.year + '' + a.quarter) - parseInt(b.year + '' + b.quarter)))
            if (quarters.length) {
              this.hasPoints = true
            }
            this.quarters = quarters
            this.getChaptersList()
            this.$nextTick(() => {
              this.setProgress(quarters)
            })
          })
          .catch((err) => console.error(err))
      },
      setProgress (quarters) {
        let focusArea = this.user.company.company_focus_area
        let score = 0
        if (focusArea !== null) {
          this.company.focusArea.id = focusArea.id
          if (this.selectedHightCont === 1) {
            this.company.focusArea.image = focusArea.image_high
          } else {
            this.company.focusArea.image = focusArea.image
          }
          if (focusArea.slug === 'policies') {
            if (quarters[0]) {
              score = quarters[0].policies_score
            }
            this.setCompanyProgress(score, '.progress__value')
            this.setFocusAreaLevel(score)
            this.company.focusArea.name = 'Policies and procedures'
          } else if (focusArea.slug === 'finding') {
            if (quarters[0]) {
              score = quarters[0].finding_score
            }
            this.setCompanyProgress(score, '.progress__value')
            this.setFocusAreaLevel(score)
            this.company.focusArea.name = 'Finding talent'
          } else if (focusArea.slug === 'assessing') {
            if (quarters[0]) {
              score = quarters[0].assessing_score
            }
            this.setCompanyProgress(score, '.progress__value')
            this.setFocusAreaLevel(score)
            this.company.focusArea.name = 'Assessing talent'
          } else if (focusArea.slug === 'retaining') {
            if (quarters[0]) {
              score = quarters[0].retaining_score
            }
            this.setCompanyProgress(score, '.progress__value')
            this.setFocusAreaLevel(score)
            this.company.focusArea.name = 'Retaining talent'
          }
        }
        this.company.level.score = score
      },
      setFocusAreaLevel (score) {
        if (score > 79) {
          this.company.level.id = 5
          this.company.level.name = 'Platinum'
          return
        }
        if (score > 59) {
          this.company.level.id = 4
          this.company.level.name = 'Gold'
          return
        }
        if (score > 39) {
          this.company.level.id = 3
          this.company.level.name = 'Silver'
          return
        }
        if (score > 19) {
          this.company.level.id = 2
          this.company.level.name = 'Bronze'
          return
        }
        if (score >= 0) {
          this.company.level.id = 1
          this.company.level.name = 'Foundation'
          return
        }
      },
      getFocusAreaLevel (score) {
        if (score > 79) {
          return {
            id: 5,
            name: 'Platinum'
          }
        }
        if (score > 59) {
          return {
            id: 4,
            name: 'Gold'
          }
        }
        if (score > 39) {
          return {
            id: 3,
            name: 'Silver'
          }
        }
        if (score > 19) {
          return {
            id: 2,
            name: 'Bronze'
          }
        }
        if (score >= 0) {
          return {
            id: 1,
            name: 'Foundation'
          }
        }
      },
      setCompanyProgress (value, selector) {
        let RADIUS = 44
        let CIRCUMFERENCE = 2 * Math.PI * RADIUS
        let progressValue = document.querySelector(selector)
        let progress = value / 100
        if (progressValue) {
          progressValue.style.display = 'block'
          progressValue.style.strokeDasharray = CIRCUMFERENCE
          progressValue.style.strokeDashoffset = CIRCUMFERENCE * (1 - progress)
        }
      },
      convertDate (payload, delimiter, monthName) {
        if (!payload) return
        let date = new Date(payload)
        let fullYear = date.getFullYear()
        let month = date.getMonth() + 1
        let day = date.getDate()
        if (monthName) {
          let months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
          month = months[month - 1]
        }
        function toDoubleDigit (num) {
          return num.toString().length < 2 ? '0' + num : num.toString()
        }
        return toDoubleDigit(day) + delimiter + toDoubleDigit(month) + delimiter + fullYear
      },
      getCurrentDate () {
        let date = new Date()
        let day = date.getDate()
        let month = date.getMonth() + 1
        let fullYear = date.getFullYear()
        let months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
        let m = months[month - 1]
        return m + ' ' + day + ', ' + fullYear
      },
      getChaptersList () {
        let self = this
        this.$http.get(api.URLS.contentChaptersList, api.headersAuthSettings)
          .then((res) => {
            let chapters = res.body
            let order = ['policies', 'finding', 'assessing', 'retaining']
            chapters.sort(function (x, y) {
              let xkey = order.indexOf(x.slug)
              let ykey = order.indexOf(y.slug)
              return xkey - ykey
            })
            let focusArea = this.user.company.company_focus_area
            let quarters = this.user.company.points.sort((a, b) => -1 * (parseInt(a.year + '' + a.quarter) - parseInt(b.year + '' + b.quarter)))
            let lastQuarter = quarters.length ? quarters[0] : null
            let newChapters = []
            let chartData = []
            let quarterData = {}
            let customChapters = {}
            let addThis
            chapters.forEach((chapter) => {
              let scores = {}
              let score = []
              let i = 1
              customChapters = chapter
              self.reverseItems(quarters).forEach(function (quarter) {
                if (!quarterData[quarter.id]) {
                  quarterData[quarter.id] = []
                }
                if (chapter.slug === 'policies') {
                  let bottom
                  let quarterScore = quarter.policies_score ? quarter.policies_score : 0
                  let benchmarkScore = self.user.company.industry && self.user.company.industry.benchmark_policies_and_procedures ? self.user.company.industry.benchmark_policies_and_procedures : null
                  let countInRange = quarterData[quarter.id].filter(x => x > (quarterScore - 2) && x < (quarterScore + 2)).length
                  let countChapterInRange = quarterData[quarter.id].filter(x => x <= quarterScore - 10).length
                  if (quarterScore <= 5) {
                    addThis = 5
                  }
                  customChapters.top = 100 - (quarterScore + (countChapterInRange * 20)) - addThis
                  quarterData[quarter.id].push(quarterScore)
                  bottom = quarterScore + (countInRange * 0.95)
                  score.push({
                    score: quarterScore,
                    left: i * 140,
                    top: 100 - bottom,
                    benchmark: benchmarkScore
                  })
                } else if (chapter.slug === 'finding') {
                  let bottom
                  let quarterScore = quarter.finding_score ? quarter.finding_score : 0
                  let benchmarkScore = self.user.company.industry && self.user.company.industry.benchmark_finding_talent ? self.user.company.industry.benchmark_finding_talent : null
                  let countInRange = quarterData[quarter.id].filter(x => x > (quarterScore - 2) && x < (quarterScore + 2)).length
                  let countChapterInRange = quarterData[quarter.id].filter(x => x <= quarterScore - 10).length
                  if (quarterScore <= 5) {
                    addThis = 5
                  }
                  customChapters.top = 100 - (quarterScore + (countChapterInRange * 20)) - addThis
                  quarterData[quarter.id].push(quarterScore)
                  bottom = quarterScore + (countInRange * 0.95)
                  score.push({
                    score: quarterScore,
                    left: i * 140,
                    top: 100 - bottom,
                    benchmark: benchmarkScore
                  })
                } else if (chapter.slug === 'assessing') {
                  let bottom
                  let quarterScore = quarter.assessing_score ? quarter.assessing_score : 0
                  let benchmarkScore = self.user.company.industry && self.user.company.industry.benchmark_accessing_talent ? self.user.company.industry.benchmark_accessing_talent : null
                  let countInRange = quarterData[quarter.id].filter(x => x > (quarterScore - 2) && x < (quarterScore + 2)).length
                  let countChapterInRange = quarterData[quarter.id].filter(x => x <= quarterScore - 10).length
                  if (quarterScore <= 5) {
                    addThis = 5
                  }
                  customChapters.top = 100 - (quarterScore + (countChapterInRange * 20)) - addThis
                  quarterData[quarter.id].push(quarterScore)
                  bottom = quarterScore + (countInRange * 0.95)
                  score.push({
                    score: quarterScore,
                    left: i * 140,
                    top: 100 - bottom,
                    benchmark: benchmarkScore
                  })
                } else if (chapter.slug === 'retaining') {
                  let bottom
                  let quarterScore = quarter.retaining_score ? quarter.retaining_score : 0
                  let benchmarkScore = self.user.company.industry && self.user.company.industry.benchmark_retaining_talent ? self.user.company.industry.benchmark_retaining_talent : null
                  let countInRange = quarterData[quarter.id].filter(x => x > (quarterScore - 2) && x < (quarterScore + 2)).length
                  let countChapterInRange = quarterData[quarter.id].filter(x => x <= quarterScore - 10).length
                  if (quarterScore <= 5) {
                    addThis = 5
                  }
                  customChapters.top = 100 - (quarterScore + (countChapterInRange * 20)) - addThis
                  quarterData[quarter.id].push(quarterScore)
                  bottom = quarterScore + (countInRange * 0.95)
                  score.push({
                    score: quarterScore,
                    left: i * 140,
                    top: 100 - bottom,
                    benchmark: benchmarkScore
                  })
                }
                i += 1
              })
              chartData[chapter.id] = {
                chapter: chapter,
                isFocus: focusArea ? focusArea.id === chapter.id : false,
                scores: score
              }
              if (chapter.slug === 'policies') {
                let score = lastQuarter ? lastQuarter.policies_score : 0
                scores = {
                  score: score,
                  level: self.getFocusAreaLevel(score)
                }
              } else if (chapter.slug === 'finding') {
                let score = lastQuarter ? lastQuarter.finding_score : 0
                scores = {
                  score: score,
                  level: self.getFocusAreaLevel(score)
                }
              } else if (chapter.slug === 'assessing') {
                let score = lastQuarter ? lastQuarter.assessing_score : 0
                scores = {
                  score: score,
                  level: self.getFocusAreaLevel(score)
                }
              } else if (chapter.slug === 'retaining') {
                let score = lastQuarter ? lastQuarter.retaining_score : 0
                scores = {
                  score: score,
                  level: self.getFocusAreaLevel(score)
                }
              }
              newChapters.push({
                chapter: chapter,
                isFocus: focusArea ? focusArea.id === chapter.id : false,
                scores: scores,
                isReady: true,
                keyShown: false
              })
              self.chartData = chartData
            })
            this.chapters = newChapters
            Array.isArray(this.chapters)
            this.dataLoaded = true
            self.$nextTick(() => {
              if (this.getUserRole !== 'ta' && this.getUserRole !== 'tu') {
                self.connectPoints()
                self.setChaptersProgress()
              }
            })
          })
          .catch((err) => {
            console.log(err)
          })
      },
      htmlToCanvas () {
        html2canvas(document.querySelector('.content-chart-wrapper')).then(function (canvas) {
          var link = document.createElement('a')
          link.download = 'metoda1.png'
          link.href = canvas.toDataURL()
          link.click()
        })
      },
      htmlToCanvas2 () {
        this.loading = true
        let chartWidth = this.getChartWidthInteger(this.chartData, true)
        let minWidth = chartWidth + 120 > 1020 ? chartWidth + 120 : 1020
        document.querySelector('.content-chart-body').style.overflow = 'visible'
        document.querySelector('.progress-section > div').style.paddingTop = '35px'
        document.querySelector('.progress-section .content-section-title').classList.add('hide-before-element')
        htmlToImage.toPng(document.querySelector('.progress-section > div'), {
          quality: 1,
          width: minWidth,
          backgroundColor: '#ffffff'
        }).then((dataUrl) => {
          this.loading = false
          document.querySelector('.content-chart-body').style.overflow = ''
          document.querySelector('.progress-section > div').style.paddingTop = ''
          document.querySelector('.progress-section .content-section-title').classList.remove('hide-before-element')
          let link = document.createElement('a')
          link.download = 'progress-chart.png'
          link.href = dataUrl
          link.click()
        }).catch(() => {
          this.loading = false
          document.querySelector('.content-chart-body').style.overflow = ''
          document.querySelector('.progress-section > div').style.paddingTop = ''
          document.querySelector('.progress-section .content-section-title').classList.remove('hide-before-element')
        })
      },
      setChaptersProgress () {
        let self = this
        self.chapters.forEach(function (chapter) {
          if (chapter.isReady) {
            let score = chapter.scores.score
            let selector = '.progress__value-' + chapter.chapter.id
            self.setCompanyProgress(score, selector)
          }
        })
      },
      reverseItems (items) {
        if (items) {
          return items.slice().reverse()
        }
      },
      connectPoints () {
        let chapters = document.querySelectorAll('.content-chart-points')
        for (let i = 0; i < chapters.length; i++) {
          let children = chapters[i].querySelectorAll('.content-chart-point')
          for (let n = 0; n < children.length; n++) {
            let isLast = false
            let fromPoint = children[n]
            let toPoint = children[n + 1]
            if (!toPoint) {
              toPoint = document.getElementById(fromPoint.getAttribute('data-chapter'))
              isLast = true
            }
            if (fromPoint !== undefined && toPoint !== undefined) {
              let el1 = fromPoint
              let el2 = toPoint
              let x1
              let x2
              let y1
              let y2
              let color = fromPoint.getAttribute('data-color')

              if (isLast) {
                x1 = el1.offsetLeft + 15
                y1 = (el1.offsetTop + el1.offsetHeight / 2) - 6
                x2 = el2.offsetLeft + 15
                y2 = (el2.offsetTop + el1.offsetHeight / 2) + 5
              } else {
                x1 = el1.offsetLeft + el1.offsetWidth - 2
                y1 = el1.offsetTop + el1.offsetHeight - 11
                x2 = el2.offsetLeft + el2.offsetWidth
                y2 = el2.offsetTop
              }

              let length = Math.sqrt(((x2 - x1) * (x2 - x1)) + ((y2 - y1) * (y2 - y1)))
              let cx = ((x1 + x2) / 2) - (length / 2) - 5
              let cy = ((y1 + y2) / 2) - (3 / 2) + 5
              let angle = Math.atan2((y1 - y2), (x1 - x2)) * (180 / Math.PI)
              let line = document.createElement('div')
              line.style['-webkit-transform'] = 'rotate(' + angle + 'deg)'
              line.style['-moz-transform'] = 'rotate(' + angle + 'deg)'
              line.style['-ms-transform'] = 'rotate(' + angle + 'deg)'
              line.style['-o-transform'] = 'rotate(' + angle + 'deg)'
              line.style['-transform'] = 'rotate(' + angle + 'deg)'
              line.style.width = length + 'px'

              if (isLast) {
                line.style.backgroundColor = 'transparent'
                line.style.borderTop = '3px dashed ' + color
              } else {
                line.style.backgroundColor = color
              }

              line.style.position = 'absolute'
              line.style.left = cx + 'px'
              line.style.top = cy + 'px'
              line.style.height = 3 + 'px'
              try {
                document.body.onload = setTimeout(function () {
                  const chartData = document.querySelector('.content-chart-data')
                  if (chartData) {
                    chartData.appendChild(line)
                  }
                }, 500)
              } catch (err) {}
              isLast = false
            }
          }
        }
        document.querySelector('.content-chart-body').scrollLeft = document.querySelector('.content-chart-body').scrollWidth
      },
      addChapterHover (chapter, hoverActive) {
        for (let index in this.chartData) {
          if (this.chartData[index].hover && chapter.chapter.id !== this.chartData[index].chapter.id) {
            this.chartData[index].hover.show = false
          }
          if (chapter.chapter.id === this.chartData[index].chapter.id) {
            let editedChapter = this.chartData[index]
            let scores = this.chartData[index].scores
            let top
            let create = this.chartData[index].hover ? !this.chartData[index].hover.show : true
            if (hoverActive === 'benchmark') {
              top = scores[scores.length - 1].benchmark
            } else {
              top = scores[scores.length - 1].score
            }
            editedChapter.hover = {
              type: hoverActive,
              show: create,
              top: top
            }
            Vue.set(this.chartData, index, editedChapter)
          }
        }
      },
      getChartWidth (chartData, full) {
        if (chartData !== null) {
          let rightMargin = 0
          if (full) {
            rightMargin = 350
          }
          return (chartData.filter(item => item !== null)[0].scores.length * 140 + rightMargin) + 'px'
        }
      },
      getChartWidthInteger (chartData, full) {
        if (chartData !== null) {
          let rightMargin = 0
          if (full) {
            rightMargin = 350
          }
          return (chartData.filter(item => item !== null)[0].scores.length * 140 + rightMargin)
        }
      },
      getChapterTopPosition (chapter) {
        return chapter.top + '%'
      },
      getChapterBackground (chapter) {
        if (this.selectedHightCont === 1) {
          return 'url(' + chapter.image_high + ')'
        } else {
          return 'url(' + chapter.image + ')'
        }
      },
      getChapterCustomName (chapter) {
        let name = null
        if (chapter.slug === 'finding') {
          if (this.user && this.user.company && this.user.company.industry && this.user.company.industry.chapter_finding_talent) {
            name = this.user.company.industry.chapter_finding_talent.title
          } else if (this.user && this.user.company && this.user.company.industry && this.user.company.industry.parent &&
            this.user.company.industry.parent.chapter_finding_talent) {
            name = this.user.company.industry.parent.chapter_finding_talent.title
          }
        } else if (chapter.slug === 'policies') {
          if (this.user && this.user.company && this.user.company.industry && this.user.company.industry.chapter_policies_and_procedures) {
            name = this.user.company.industry.chapter_policies_and_procedures.title
          } else if (this.user && this.user.company && this.user.company.industry && this.user.company.industry.parent &&
            this.user.company.industry.parent.chapter_policies_and_procedures) {
            name = this.user.company.industry.parent.chapter_policies_and_procedures.title
          }
        } else if (chapter.slug === 'assessing') {
          if (this.user && this.user.company && this.user.company.industry && this.user.company.industry.chapter_accessing_talent) {
            name = this.user.company.industry.chapter_accessing_talent.title
          } else if (this.user && this.user.company && this.user.company.industry && this.user.company.industry.parent &&
            this.user.company.industry.parent.chapter_accessing_talent) {
            name = this.user.company.industry.parent.chapter_accessing_talent.title
          }
        } else if (chapter.slug === 'retaining') {
          if (this.user && this.user.company && this.user.company.industry && this.user.company.industry.chapter_retaining_talent) {
            name = this.user.company.industry.chapter_retaining_talent.title
          } else if (this.user && this.user.company && this.user.company.industry && this.user.company.industry.parent &&
            this.user.company.industry.parent.chapter_retaining_talent) {
            name = this.user.company.industry.parent.chapter_retaining_talent.title
          }
        }

        if (!name) {
          return chapter.name
        } else {
          return name
        }
      },
      getContentPageProps (chapter) {
        let id
        if (chapter.slug === 'finding') {
          if (this.user && this.user.company && this.user.company.industry && this.user.company.industry.chapter_finding_talent) {
            id = this.user.company.industry.chapter_finding_talent.id
          } else if (this.user && this.user.company && this.user.company.industry && this.user.company.industry.parent &&
            this.user.company.industry.parent.chapter_finding_talent) {
            id = this.user.company.industry.parent.chapter_finding_talent.id
          } else {
            id = 131
          }
        } else if (chapter.slug === 'policies') {
          if (this.user && this.user.company && this.user.company.industry && this.user.company.industry.chapter_policies_and_procedures) {
            id = this.user.company.industry.chapter_policies_and_procedures.id
          } else if (this.user && this.user.company && this.user.company.industry && this.user.company.industry.parent &&
            this.user.company.industry.parent.chapter_policies_and_procedures) {
            id = this.user.company.industry.parent.chapter_policies_and_procedures.id
          } else {
            id = 132
          }
        } else if (chapter.slug === 'assessing') {
          if (this.user && this.user.company && this.user.company.industry && this.user.company.industry.chapter_accessing_talent) {
            id = this.user.company.industry.chapter_accessing_talent.id
          } else if (this.user && this.user.company && this.user.company.industry && this.user.company.industry.parent &&
            this.user.company.industry.parent.chapter_accessing_talent) {
            id = this.user.company.industry.parent.chapter_accessing_talent.id
          } else {
            id = 130
          }
        } else if (chapter.slug === 'retaining') {
          if (this.user && this.user.company && this.user.company.industry && this.user.company.industry.chapter_retaining_talent) {
            id = this.user.company.industry.chapter_retaining_talent.id
          } else if (this.user && this.user.company && this.user.company.industry && this.user.company.industry.parent &&
            this.user.company.industry.parent.chapter_retaining_talent) {
            id = this.user.company.industry.parent.chapter_retaining_talent.id
          } else {
            id = 133
          }
        }
        return {
          name: 'content',
          params: { id: id }
        }
      },
      hasBenchmark (chapter) {
        if (chapter.scores.length) {
          if (chapter.scores[chapter.scores.length - 1].benchmark !== null) {
            return true
          } else {
            return false
          }
        } else {
          return false
        }
      },
      getChapterIndex (c) {
        let scores = []
        let chartData = this.chartData
        let index = 0
        if (c.scores.length) {
          for (let index in chartData) {
            let chapter = chartData[index]
            scores.push(chapter.scores[chapter.scores.length - 1].top)
          }
          let orderedScores = scores.sort((a, b) => a - b)
          index = orderedScores.indexOf(c.scores[c.scores.length - 1].top)
        }
        return index
      },
      getBadgeLink () {
        let props = this.$router.resolve({
          name: 'badge'
        })
        return props.href
      },
      getIframeCode () {
        let url = location.origin + this.getBadgeLink() + '?company=' + this.user.company.hash + '&theme=' + this.iframeTheme.value
        return '<iframe title="' + (this.user && this.user.company ? this.user.company.name + ' badge' : 'Company badge') + '" width="210" height="85" src="' + url + '" style="border: none;"></iframe>'
      },
      copyIframe () {
        document.getElementById('iframeCode').select()
        document.execCommand('copy')
      },
      reloadIframe () {
        let iframe = document.getElementById('previewIframe')
        iframe.src = iframe.src
      },
      getImagePath () {
        return api.serverURL + '/uploads/images/content/'
      },
      isBase64 (payload) {
        if (!payload && payload !== '') {
          return true
        }
        return payload.indexOf('data:') !== -1
      },
      getImage (payload) {
        if (!payload) {
          return ''
        }
        return this.isBase64(payload) ? 'url(' + payload + ')' : 'url(' + this.getImagePath() + payload + ')'
      },
      getImageFullPath (payload) {
        if (!payload) {
          return ''
        }
        return this.isBase64(payload) ? payload : this.getImagePath() + payload
      }
    },
    watch: {
      'badgeCopy' (value) {
        if (value) {
          setTimeout(function () {
            document.getElementById('confirmation-popup-title').setAttribute('tabindex', '-1')
            document.getElementById('confirmation-popup-title').focus()
          }, 100)
        }
      },
      selectedHightCont () {
        let iframe = document.getElementById('contentCompanyBadge').firstChild
        iframe.src = iframe.src
      },
      'iframeTheme' () {
        this.reloadIframe()
      }
    },
    mounted () {
      this.getUserInfoById()
    },
    created () {
      document.title = 'Organisation profile | Clear Assured'
      if (window._paq) {
        window._paq.push(['setCustomUrl', location.pathname])
        window._paq.push(['setDocumentTitle', document.title])
        window._paq.push(['trackPageView'])
      }
      // if (window.ga) {
      //   window.ga('set', 'contentGroup1', 'DASHBOARD_AREA')
      //   window.ga('send', 'pageview', {
      //     'page': location.pathname,
      //     'location': location.href,
      //     'title': document.title
      //   })
      // }
    },
    destroyed () {}
  }
</script>

<style src='@/assets/scss/components/profile.scss' lang='scss' />
<style src="@/assets/scss/components/dashboard.scss" lang="scss" scoped />



// WEBPACK FOOTER //
// CompanyProfile.vue?dc49b2bc